'use strict'

const POWERBI_API_SUCCESS = 'POWERBI_API_SUCCESS';
const POWERBI_API_FAILURE = 'POWERBI_API_FAILURE';
const POWERBI_TYPE_HOMEPAGE = 'HOMEPAGE';
const POWERBI_TABLENAME_HOMEPAGE = 'PHX_HOMEPAGE';
const POWERBI_REPORT_HOMEPAGE = 'PHX_RPT_PBI_HOMEPAGE';
const POWERBI_TYPE_INCIDENT = 'INCIDENTS';
const POWERBI_REPORT_INCIDENT = 'PHX_RPT_PBI_INST_DASHBOARD';
const POWERBI_GROUP_API_SUCCESS = 'POWERBI_GROUP_API_SUCCESS'
const POWERBI_GROUP_API_FAILURE = 'POWERBI_GROUP_API_FAILURE'
const POWERBI_GROUP_URL ='https://api.powerbi.com/v1.0/myorg/groups'
const POWERBI_DASHBOARD_TABS = 'INCIDENTS,SYSTEM,Calibration,Cal_Assay_Name,QC,QC_Assay_Name,PHX_RPT_METRIC_NAME_MEAS,CAL_ASSAY_STATUS,QC_ASSAY_STATUS,SYS_COMP_METRIC_NAME,EVENT_DETAILS';
const POWERBI_DASHBOARD_FILTER_UNDEFINED= "undefined";
const POWERBI_SYS_COMP_SUBCOMP = "Component_Path";
const POWERBI_TABLENAME_SYSCOMP_GRAPH = "PHX_RPT_METRIC_NAME_MEAS";
const POWERBI_TBLNAME_SYSCOMP_METR = "SYS_COMP_METRIC_NAME";
const DATETIME_FORMAT = "YYYY-MM-DDTHH:mm:ss";
const POWERBI_MULTI_DASHBOARD_TABS = 'INCIDENTS,EVENT_DETAILS,SYSTEM,PHX_RPT_METRIC_NAME_MEAS,SYS_COMP_METRIC_NAME'; 
const POWERBI_DEVICE_STATE_ADD = 'POWERBI_DEVICE_STATE_ADD';
const POWERBI_DEVICE_STATE_REMOVE = 'POWERBI_DEVICE_STATE_REMOVE';
const INCIDENTS_START_DATE='INCIDENTS_START_DATE';
const INCIDENTS_END_DATE='INCIDENTS_END_DATE';
const INCIDENTS_DATE_SLICER_STATE="INCIDENTS_DATE_SLICER_STATE";
const INCIDENTS_COMPONENT_SLICER_STATE="INCIDENTS_COMPONENT_SLICER_STATE";
const DEFAULT_DATE_SLICER_STATE="DEFAULT_DATE_SLICER_STATE";
const INCIDENTS_CATEGORY_SLICER_STATE="INCIDENTS_CATEGORY_SLICER_STATE";
export {
    POWERBI_API_SUCCESS,
    POWERBI_API_FAILURE,
    POWERBI_GROUP_API_SUCCESS,
    POWERBI_GROUP_API_FAILURE,
    POWERBI_GROUP_URL,
    POWERBI_TYPE_HOMEPAGE,
    POWERBI_TABLENAME_HOMEPAGE,
    POWERBI_REPORT_HOMEPAGE,
    POWERBI_TYPE_INCIDENT,
    POWERBI_REPORT_INCIDENT,
    POWERBI_DASHBOARD_TABS,
    POWERBI_DASHBOARD_FILTER_UNDEFINED,
    POWERBI_SYS_COMP_SUBCOMP,
    POWERBI_TABLENAME_SYSCOMP_GRAPH,
    POWERBI_TBLNAME_SYSCOMP_METR,
    DATETIME_FORMAT,
    POWERBI_MULTI_DASHBOARD_TABS,
    POWERBI_DEVICE_STATE_ADD,
    POWERBI_DEVICE_STATE_REMOVE,
    INCIDENTS_START_DATE,
    INCIDENTS_END_DATE,
    INCIDENTS_DATE_SLICER_STATE,
    INCIDENTS_COMPONENT_SLICER_STATE,
    DEFAULT_DATE_SLICER_STATE,
    INCIDENTS_CATEGORY_SLICER_STATE
}